// Importing the canonical user-guide markdown that ships with the agents
// package as the orchestrator's `read_user_guide` payload, so the UI and
// the agent stay in lockstep without two copies of the document. The
// `@atbash-labs/ontology-agents/assets/*` alias lives in tsconfig.base.json.
// eslint-disable-next-line @nx/enforce-module-boundaries
import content from '@atbash-labs/ontology-agents/assets/ontology-user-guide.md?raw'
import MarkdownDocPage from '../../components/MarkdownDocPage/MarkdownDocPage'

const GuidePage = () => (
  <MarkdownDocPage
    title="User Guide"
    subtitle="Step-by-step feature documentation."
    content={content}
  />
)

export default GuidePage
